import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { enumMap, RBDTransmissionType } from "../../app/config/enum";
import { useStore } from "../../app/stores/store";

function RBDSettingTransmissionType() {
    const { rbdStore } = useStore();

    const handleChange = (e: SelectChangeEvent<RBDTransmissionType>) => {
        rbdStore.setSelectedTransmissionType(e.target.value as RBDTransmissionType);
    }

    return (
        <FormControl fullWidth sx={{mb:4}}>
            <InputLabel id="transmissionTypeLabel">Transmission Type</InputLabel>
            <Select
                labelId="transmissionTypeLabel"
                value={rbdStore.selectedTransmissionType}
                label="Transmission Type"
                onChange={(e) => handleChange(e)}
            >
                {enumMap(RBDTransmissionType, (value, desc, idx) => (
                    <MenuItem key={idx} value={value}>{desc}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default observer(RBDSettingTransmissionType);